// 몹·보스 공용 툰 그라데이션(ART-BIBLE 3장: 2단 + 부드러운 경계).
// MeshToon 기본값은 밝기 0.7/1.0 경계가 칼같이 끊겨, 구겨진 Tripo 메시에서 면 조각이 도드라진다.
// 그림자 0.42 → 밝음 1.0을 dotNL 약 0~0.44 구간에서 부드럽게 잇는 1D 텍스처(선형 필터)를 쓴다.
// 바닥 0.6은 텍스처 명암을 눌러 몹·보스가 베이지 덩어리로 보였다(VFX/룩 레인 측정 2026-10-14, qa/vfx/look/m1p-4:
// 같은 프레임 몸 화소 밝기 표준편차 몹 0.171→0.177, 보스 0.150→0.158. 표준 조명은 +15%지만 그늘이 너무 어두워 2단 툰을 유지).
import * as THREE from 'three/webgpu';

let shared: THREE.DataTexture | null = null;

export function toonGradient(): THREE.DataTexture {
  if (shared) return shared;
  const w = 64;
  const data = new Uint8Array(w * 4);
  for (let i = 0; i < w; i++) {
    // 좌표 = dotNL * 0.5 + 0.5
    const x = i / (w - 1);
    const t = Math.min(1, Math.max(0, (x - 0.5) / 0.22));
    const s = t * t * (3 - 2 * t);
    const v = Math.round((0.42 + 0.58 * s) * 255);
    data[i * 4] = v; data[i * 4 + 1] = v; data[i * 4 + 2] = v; data[i * 4 + 3] = 255;
  }
  const tex = new THREE.DataTexture(data, w, 1, THREE.RGBAFormat);
  tex.magFilter = THREE.LinearFilter;
  tex.minFilter = THREE.LinearFilter;
  tex.generateMipmaps = false;
  tex.wrapS = tex.wrapT = THREE.ClampToEdgeWrapping;
  tex.needsUpdate = true;
  shared = tex;
  return tex;
}
